/** Constantes partagées formulaire / liste clients admin */

export const MODELS = [
  "mistral-small-latest",
  "ministral-14b-latest",
  "magistral-small-latest",
  "mistral-medium-latest",
  "mistral-large-latest",
];

export const EMPTY_FORM = {
  name: "",
  slug: "",
  portal_password: "",
  primary_color: "#8d282a",
  secondary_color: "#010101",
  logo_url: "",
  welcome_message: "Bonjour ! Comment puis-je vous aider ?",
  system_prompt: "",
  temperature: 0.3,
  max_tokens: 1024,
  llm_model: "mistral-small-latest",
  max_storage_bytes: 524288000,
  /** null = hériter de la config globale (.env) */
  rag_retrieval_top_k: null,
  rag_max_context_chunks: null,
  /** null = illimité */
  max_chatbot_users: null,
  max_chatbot_user_messages_monthly: null,
  local_agent_enabled: false,
};

export const buildNewForm = (defaultConfig) =>
  defaultConfig ? { ...EMPTY_FORM, ...defaultConfig } : EMPTY_FORM;
